import React from "react";
import PropTypes from "prop-types";

import { useQuery } from "react-query";
import { fetchTauxReclamationSociete } from 'utils/queries';


const TauxReclamation = ({ client }) => {

    const {
        isLoading,
        error,
        data,
        //isFetching,
        //refetch,
    } = useQuery(["TauxReclamationSociete"], () => fetchTauxReclamationSociete(), {});


    if (!client.id || !client.tauxReclamation) {
        return null;
    }

    if (error) {
        return (
            <p>Echec de récupération du taux de dossier après-vente, veuillez contacter le support.</p>
        );
    }

    if (isLoading || !data) {
        return null;
    }

    const tauxSociete = data.toFixed(2);
    const tauxClient = client.tauxReclamation ? (client.tauxReclamation.nbReclamations * 100 / client.tauxReclamation.nbBLExpedies).toFixed(2) : 0;

    return (
        <>
            <p>Taux de dossier après-vente société : {tauxSociete}% - Taux de dossier après-vente client : <span style={{ backgroundColor: '#9FB17C', padding: '8px', color: 'white', fontWeight: 'bold' }}>{tauxClient}%</span></p>
            <p>Sur les 6 derniers mois, au client, Nb d'expédition : {client.tauxReclamation.nbBLExpedies} - Nb dossier après-vente : {client.tauxReclamation.nbReclamations}</p>
        </>
    );
}

TauxReclamation.propTypes = {
    client: PropTypes.object.isRequired,
};

export default TauxReclamation;
